import { Block } from 'slate';
import getTableColumnCountForCells from '../utils/getTableColumnCountForCells';
export default function getTableRowCells(editor, tableOrTableId, rowIndex) {
  var cells;

  if (Block.isBlock(tableOrTableId)) {
    cells = tableOrTableId.nodes;
  } else {
    cells = editor.getTableCells(tableOrTableId);
  }

  var columnCount = getTableColumnCountForCells(cells);
  return cells.filter(function (_cell, i) {
    return i >= rowIndex * columnCount && i < rowIndex * columnCount + columnCount;
  });
}